import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "sr-only" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-footer" }
const _hoisted_6 = { class: "grid-container" }
const _hoisted_7 = { class: "grid-x grid-padding-x" }
const _hoisted_8 = { class: "modal-multi-form-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-animation" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: "modal",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.outSideClick && _ctx.outSideClick(...args))),
        id: _ctx.id
      }, [
        _createVNode(_Transition, { name: "modal-animation-inner" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["modal-inner", _ctx.modalSize])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "close button small clear icon",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uiOptions().toggleModal(_ctx.id)))
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("i", {
                  class: "bi bi-x-lg",
                  "aria-hidden": "true"
                }, null, -1)),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('messages.modals.actions.close')), 1)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "modal-header", {}, undefined, true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "modal-body", {}, undefined, true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _renderSlot(_ctx.$slots, "modal-footer", {}, undefined, true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "modal-multi-form-buttons", {}, undefined, true)
              ])
            ], 2), [
              [_vShow, _ctx.uiOptions().isModalOpen[_ctx.id]]
            ])
          ]),
          _: 3
        })
      ], 8, _hoisted_1), [
        [_vShow, _ctx.uiOptions().isModalOpen[_ctx.id]]
      ])
    ]),
    _: 3
  }))
}